var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"talk_parent"},[_c('img',{staticClass:"ai_head_img2",attrs:{"src":require("../../assets/ai_head_msg.png")}}),_c('div',{staticClass:"triangle_border_left"}),_c('div',{staticClass:"talk_div"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }